export default "__VITE_ASSET__peVJF$SY__"